import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { onboardingPath } from "../../core/primitives/onboarding";
import { OnboardingShowController } from "./onboarding-show-controller";
import { OnboardingShowPage } from "./onboarding-show-page";

export function OnboardingShowRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  return (
    <Subtree
      key="onboarding-show"
      controller={() =>
        new OnboardingShowController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository", "stripePayments"),
          {
            toSelling: (storeId) => navigate(onboardingPath("selling", storeId)),
            toPayments: (storeId) => navigate(onboardingPath("payments", storeId)),
          },
        )
      }
    >
      <OnboardingShowPage />
    </Subtree>
  );
}
